const PATHS = {
  BASE_PATH: 'https://5ee4fc53ddcea00016a37177.mockapi.io/api/v1',
  TASKS_PATH: '/tasks',
};

export default PATHS;
